
export default function ConfirmDirective($confirm: Function) {
    return {
        priority: 1,
        restrict: 'A',
        scope: {
            confirmIf: '=',
            ngClick: '&',
            confirm: '@'
        },
        link(scope: any, element: JQLite, attrs: any) {
            function reBind(func: Function) {
                element.unbind('click').bind('click', function(event: Event) {
                    func(event);
                });
            }

            function bindConfirm(event: Event) {
                event.stopPropagation();
                $confirm({ text: scope.confirm }).then(scope.ngClick);
            }

            if ('confirmIf' in attrs) {
                scope.$watch('confirmIf', function() {
                    reBind(bindConfirm);
                });
            } else {
                reBind(bindConfirm);
            }
        }
    };
}
ConfirmDirective.$inject = ['$confirm'];
